"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    install: function (Vue, options) {
        function api() { }
        for (var key in options) {
            api[key] = options[key];
        }
        Vue.prototype.$api = api;
    },
};
